import React, { useState } from "react";
import { loginUsuario, recuperarSenha } from "../firebase";

const LOGO = process.env.PUBLIC_URL + '/logo512.png';

export default function Login({ onLogin, onNavegar }) {
  const [email,        setEmail]        = useState("");
  const [senha,        setSenha]        = useState("");
  const [erro,         setErro]         = useState("");
  const [carregando,   setCarregando]   = useState(false);
  const [telaAtual,    setTelaAtual]    = useState("login");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [enviado,      setEnviado]      = useState(false);
  const [enviando,     setEnviando]     = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setErro("");
    setCarregando(true);
    try {
      const { perfil } = await loginUsuario(email, senha);
      if (!perfil) {
        setErro("Perfil não encontrado. Contate o suporte.");
        setCarregando(false);
        return;
      }
      localStorage.setItem("perfil", JSON.stringify(perfil));
      onLogin(perfil.perfil);
    } catch (err) {
      const msgs = {
        "auth/user-not-found":     "Usuário não encontrado.",
        "auth/wrong-password":     "Senha incorreta.",
        "auth/invalid-email":      "E-mail inválido.",
        "auth/invalid-credential": "E-mail ou senha incorretos.",
        "auth/too-many-requests":  "Muitas tentativas. Tente mais tarde.",
      };
      setErro(msgs[err.code] || "Erro ao fazer login. Tente novamente.");
    } finally {
      setCarregando(false);
    }
  }

  async function handleRecuperar(e) {
    e.preventDefault();
    setErro("");
    setEnviando(true);
    try {
      await recuperarSenha(email);
      setEnviado(true);
    } catch (err) {
      const msgs = {
        "auth/user-not-found": "E-mail não cadastrado.",
        "auth/invalid-email":  "E-mail inválido.",
      };
      setErro(msgs[err.code] || "Erro ao enviar e-mail. Tente novamente.");
    } finally {
      setEnviando(false);
    }
  }

  if (telaAtual === "recuperar") {
    return (
      <div style={styles.container}>
        <div style={styles.logoArea}>
          <img src={LOGO} alt="Apoio" style={styles.logoImg} />
          <h1 style={styles.titulo}>Recuperar Senha</h1>
          <p style={styles.subtitulo}>Apoio</p>
        </div>
        {enviado ? (
          <div style={styles.successBox}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>📧</div>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#1a1a2e', marginBottom: 8 }}>E-mail enviado!</div>
            <div style={{ fontSize: 12, color: '#666', lineHeight: 1.6, textAlign: 'center' }}>
              Verifique sua caixa de entrada e siga as instruções para redefinir sua senha.
            </div>
            <button onClick={() => { setTelaAtual("login"); setEnviado(false); setEmail(""); }}
              style={{ ...styles.botao, marginTop: 20 }}>
              Voltar ao Login
            </button>
          </div>
        ) : (
          <form onSubmit={handleRecuperar} style={styles.form} autoComplete="off">
            <p style={{ fontSize: 13, color: '#666', marginBottom: 16, lineHeight: 1.6 }}>
              Digite seu e-mail cadastrado e enviaremos um link para redefinir sua senha.
            </p>
            <div style={styles.campo}>
              <label style={styles.label}>E-mail cadastrado</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="seu@email.com" required style={styles.input} autoComplete="off" />
            </div>
            {erro && <div style={styles.erro}>{erro}</div>}
            <button type="submit" disabled={enviando}
              style={{ ...styles.botao, opacity: enviando ? 0.7 : 1 }}>
              {enviando ? "Enviando..." : "📧 Enviar Link de Recuperação"}
            </button>
            <button type="button" onClick={() => { setTelaAtual("login"); setErro(""); }}
              style={styles.botaoSecundario}>
              ← Voltar ao Login
            </button>
          </form>
        )}
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.logoArea}>
        <img src={LOGO} alt="Apoio" style={styles.logoImg} />
        <p style={styles.subtitulo}>PEDIDOS ONLINE</p>
      </div>
      <form onSubmit={handleLogin} style={styles.form} autoComplete="off">
        <div style={styles.campo}>
          <label style={styles.label}>E-mail</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)}
            placeholder="seu@email.com" required style={styles.input}
            autoComplete="off" name="login-email-novo" />
        </div>
        <div style={styles.campo}>
          <label style={styles.label}>Senha</label>
          <div style={{ position: 'relative' }}>
            <input type={mostrarSenha ? "text" : "password"} value={senha} onChange={e => setSenha(e.target.value)}
              placeholder="••••••••" required style={{ ...styles.input, width: '100%', boxSizing: 'border-box', paddingRight: 44 }}
              autoComplete="new-password" name="login-senha-nova" />
            <span onClick={() => setMostrarSenha(v => !v)}
              style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', fontSize: 18, userSelect: 'none' }}>
              {mostrarSenha ? '🙈' : '👁️'}
            </span>
          </div>
        </div>
        <div style={{ textAlign: 'right', marginTop: -8 }}>
          <span onClick={() => { setTelaAtual("recuperar"); setErro(""); }} style={styles.linkEsqueci}>
            Esqueci minha senha
          </span>
        </div>
        {erro && <div style={styles.erro}>{erro}</div>}
        <button type="submit" disabled={carregando}
          style={{ ...styles.botao, opacity: carregando ? 0.7 : 1, cursor: carregando ? "not-allowed" : "pointer" }}>
          {carregando ? "Entrando..." : "Entrar"}
        </button>

        {/* Box informativo abaixo do botão */}
        <div style={{
          marginTop: 20,
          background: '#f0f4ff',
          border: '1px solid #c7d7f9',
          borderRadius: 10,
          padding: '18px 16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 10,
        }}>
          <div style={{ fontSize: 15, fontWeight: 800, color: '#1a3a6b', textAlign: 'center', letterSpacing: 0.5 }}>
            APP APOIO VAREJISTA
          </div>
          <div style={{ width: 40, height: 2, background: '#c7d7f9', borderRadius: 2 }} />
          <div style={{ fontSize: 14, color: '#1a1a2e', textAlign: 'center' }}>
            Precos de Fabrica
          </div>
          <div style={{ fontSize: 14, color: '#1a1a2e', textAlign: 'center' }}>
            Faturamento Minimo R$ 2.000,00
          </div>
        </div>

      </form>
    </div>
  );
}

const styles = {
  container: { flex: 1, padding: "32px 24px", display: "flex", flexDirection: "column" },
  logoArea:  { textAlign: "center", marginBottom: 32 },
  logoImg: {
    width: 120, height: 120, borderRadius: 20,
    objectFit: "contain", marginBottom: 12,
    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
  },
  titulo:    { margin: 0, fontSize: 20, fontWeight: 700, color: "#1a1a2e" },
  subtitulo: { margin: "4px 0 0", fontSize: 12, color: "#666", letterSpacing: 2, textTransform: "uppercase" },
  form:      { display: "flex", flexDirection: "column", gap: 16 },
  campo:     { display: "flex", flexDirection: "column", gap: 6 },
  label:     { fontSize: 13, fontWeight: 600, color: "#444" },
  input:     { padding: "12px 16px", border: "2px solid #e8e8e8", borderRadius: 10, fontSize: 15, outline: "none" },
  erro:      { background: "#fff0f0", border: "1px solid #ffcdd2", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#c62828" },
  botao: {
    marginTop: 8, padding: "14px",
    background: "linear-gradient(135deg, #e63946, #c1121f)",
    color: "#fff", border: "none", borderRadius: 10,
    fontSize: 16, fontWeight: 700,
    boxShadow: "0 4px 15px rgba(230,57,70,0.4)", cursor: "pointer",
  },
  botaoSecundario: { padding: "12px", background: "#f4f4f2", color: "#666", border: "none", borderRadius: 10, fontSize: 14, fontWeight: 500, cursor: "pointer" },
  linkEsqueci:     { fontSize: 12, color: "#e63946", fontWeight: 600, cursor: "pointer", textDecoration: "underline" },
  successBox: { display: "flex", flexDirection: "column", alignItems: "center", padding: "24px 16px", background: "#f0fdf4", borderRadius: 12, border: "1px solid #bbf7d0" },
};